import React from 'react';
import SubscriptionTemplate from './SubscriptionTemplate';
import { displayMessage } from './wsHelpers';
import { connect } from 'react-redux';
import {
	createAnnouncement,
	sendAnnouncement,
	deleteAnnouncement,
	updateAnnouncement,
	addGroupsToAnnouncement,
	removeGroupsFromAnnouncement,
} from '@/redux/actions';

const WS_ANNOUNCEMENT_BY_HTTP = {
	CREATE: 'announcements/POST',
	SEND: 'announcements/onDemand/POST',
	UPDATE: 'announcements/:announcementID/PATCH',
	DELETE: 'announcements/:announcementID/DELETE',
	ADD_GROUPS: 'announcements/:announcementID/addGroups/PATCH',
	REMOVE_GROUPS: 'announcements/:announcementID/removeGroups/PATCH',
};

const AnnouncementSubscriptions = props => {
	const {
		socket,
		children,
		currentEventId,
		createAnnouncement,
		sendAnnouncement,
		deleteAnnouncement,
		updateAnnouncement,
		addGroups,
		removeGroups,
	} = props;
	const propsToSend = { ...props };
	delete propsToSend.children;

	const subscribeToEventAnnouncements = () => {
		socket.emit('announcements/:eventID/SUBSCRIBE', { eventID: currentEventId });
		console.log('⚡️ AnnouncementSubscriptions Mounted ⚡️');
	};

	const unsubscribeToEventAnnouncements = () => {
		socket.emit('announcements/:eventID/UNSUBSCRIBE', { eventID: currentEventId });
		console.log(`🚶‍♂️ AnnouncementSubscriptions Unmounted 🚶‍♂️`);
	};

	const listenForCreatedAnnouncement = () => {
		socket.on(WS_ANNOUNCEMENT_BY_HTTP.CREATE, payload => {
			const { data, error } = payload;
			if (error) displayMessage('Announcement could not be created', error);
			else {
				createAnnouncement(data);
				displayMessage('Announcement created');
			}
		});
	};

	const listenForOnDemandAnnouncement = () => {
		socket.on(WS_ANNOUNCEMENT_BY_HTTP.SEND, payload => {
			const { data, error } = payload;
			if (error) displayMessage('Announcement could not be sent', error);
			else {
				sendAnnouncement(data);
				displayMessage('Announcement sent');
			}
		});
	};

	const listenForUpdatedAnnouncement = () => {
		socket.on(WS_ANNOUNCEMENT_BY_HTTP.UPDATE, payload => {
			const { data, error } = payload;
			if (error) displayMessage('Announcement could not be updated', error);
			else {
				updateAnnouncement(data);
				displayMessage('Announcement updated');
			}
		});
	};

	const listenForDeletedAnnouncement = () => {
		socket.on(WS_ANNOUNCEMENT_BY_HTTP.DELETE, payload => {
			const { data, error } = payload;
			if (error) displayMessage('Announcement could not be deleted', error);
			else {
				deleteAnnouncement(data.id);
				displayMessage('Announcement deleted');
			}
		});
	};

	const listenForAddedGroups = () => {
		socket.on(WS_ANNOUNCEMENT_BY_HTTP.ADD_GROUPS, payload => {
			const { data, error } = payload;
			if (error) displayMessage('Groups could not be added', error);
			else {
				addGroups(data);
			}
		});
	};

	const listenForRemovedGroups = () => {
		socket.on(WS_ANNOUNCEMENT_BY_HTTP.REMOVE_GROUPS, payload => {
			const { data, error } = payload;
			if (error) displayMessage('Groups could not be removed', error);
			else {
				removeGroups(data);
			}
		});
	};

	const listeners = () => [
		listenForCreatedAnnouncement,
		listenForOnDemandAnnouncement,
		listenForUpdatedAnnouncement,
		listenForDeletedAnnouncement,
		listenForAddedGroups,
		listenForRemovedGroups,
	];
	return (
		<>
			<SubscriptionTemplate
				{...props}
				sub={subscribeToEventAnnouncements}
				unsub={unsubscribeToEventAnnouncements}
				listeners={listeners()}
				routes={Object.values(WS_ANNOUNCEMENT_BY_HTTP)}
			/>
			{React.cloneElement(children, propsToSend)}
		</>
	);
};

const msp = ({ attendee, ws, auth, events }) => ({
	attendeeID: attendee.attendeeInfo.id,
	socket: ws.socket,
	auth0Token: auth.auth0Token,
	currentEventId: events.currentEvent.id,
});

const mdp = dispatch => ({
	createAnnouncement: (announcement, from) => dispatch(createAnnouncement(announcement, from)),
	sendAnnouncement: (announcement, from) => dispatch(sendAnnouncement(announcement, from)),
	deleteAnnouncement: (announcementID, from) => dispatch(deleteAnnouncement(announcementID, from)),
	updateAnnouncement: (announcement, from) => dispatch(updateAnnouncement(announcement, from)),
	addGroups: (groupIDs, from) => dispatch(addGroupsToAnnouncement(groupIDs, from)),
	removeGroups: (groupIDs, from) => dispatch(removeGroupsFromAnnouncement(groupIDs, from)),
});

export default connect(msp, mdp)(AnnouncementSubscriptions);
